var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v("Load")]),_c('span',{attrs:{"data-value":_vm.status1}},[_vm._v(_vm._s(_vm.one))]),_c('span',{attrs:{"data-value":_vm.status5}},[_vm._v(_vm._s(_vm.five))]),_c('span',{attrs:{"data-value":_vm.status15}},[_vm._v(_vm._s(_vm.fifteen))])])
}
var staticRenderFns = []

export { render, staticRenderFns }